/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PropertyType {
    BOOLEAN = 'boolean',
    DATE = 'date',
    DATETIME = 'datetime',
    DECIMAL = 'decimal',
    DOUBLE = 'double',
    INTEGER = 'integer',
    LONG = 'long',
    STRING = 'string',
    UNSUPPORTED = 'unsupported',
}
